<div class="user">
  <div class="user__image">
    <img
      [src]="_avatar()"
      loading="lazy"
      (error)="onAvatarLoadError()"
      alt="User Avatar"
      class="user__image-avatar"
    />
  </div>

  <div class="user__info">
    <h5 class="user__info-name">{{ name() }}</h5>
    <span class="user__info-phone">{{ phone() | phone }}</span>
  </div>
</div>
